module.exports = __webpack_public_path__ + "static/media/SF-3-A.c6cefb42.mp3";